import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Accordion, Form } from 'react-bootstrap';
import 'react-multi-carousel/lib/styles.css';

//component
import Banner from '../banner/banner'
import Media from './media/media'
import Request from './requests/request'
import Departman from './departman/departman'
import Subject from './subject/subject'
import AddImage from './image/addImage'



function Branchs() {
 

  return (
    <>
    <div className='container bg-white p-3 m-3'>
      <div className='title pb-2'>
        <h6>صفحه امور مشتریان</h6>
      </div>
      <div className=''>
      <Accordion  >
          <div className=' [&>div]:px-2 [&>div]:py-3'>
            <div className='12'>
              <Accordion.Item eventKey="0">
                <Accordion.Header>بنر صفحه امور مشتریان</Accordion.Header>
                <Accordion.Body>
                <Banner slug="contactUs1"/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="2">
                <Accordion.Header>افزودن تصویر</Accordion.Header>
                <Accordion.Body>
                    <AddImage slug="contactUsImage"/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="3">
                <Accordion.Header>درگاه امور مشتریان</Accordion.Header>
                <Accordion.Body>
                    <Media/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="4">
                <Accordion.Header>لیست درخواست های ثبت شده</Accordion.Header>
                <Accordion.Body>
                    <Request/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="5">
                <Accordion.Header>دپارتمان</Accordion.Header>
                <Accordion.Body>
                    <Departman/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="6">
                <Accordion.Header>موضوع</Accordion.Header>
                <Accordion.Body>
                    <Subject/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
          </div>
        </Accordion>
      </div>
    </div>
    </>
  );
}

export default Branchs;
